/** The local-storage keys the datasheet popover's workbench pane keeps its state under. */
export const DATASHEET_POPOVER_WORKBENCH_STORAGE_KEYS = {
	isVisible: 'datasheetPopover.chatPaneVisible',
	width: 'datasheetPopover.chatPaneWidth',
} as const;
